import { GraphQLErrorCode } from '@this+that/constants';

import { getGraphQLErrorCode } from '../../utils/graphqlErrors';

const ERROR_KEY_BY_CODE: Partial<Record<GraphQLErrorCode, string>> = {
  [GraphQLErrorCode.FORBIDDEN]: 'doBox.brainSignalReview.notEligible',
  [GraphQLErrorCode.UNAUTHORIZED]: 'doBox.brainSignalReview.notEligible',
  [GraphQLErrorCode.NOT_FOUND]: 'doBox.brainSignalReview.notFound',
};

export const BRAIN_SIGNAL_REVIEW_GENERIC_ERROR_KEY =
  'doBox.brainSignalReview.respondError';

export function isBrainSignalReviewAlreadyDecided(error: unknown): boolean {
  return getGraphQLErrorCode(error) === GraphQLErrorCode.CONFLICT;
}

export function resolveBrainSignalReviewErrorKey(error: unknown): string {
  const code = getGraphQLErrorCode(error);
  return (
    (code && ERROR_KEY_BY_CODE[code]) ?? BRAIN_SIGNAL_REVIEW_GENERIC_ERROR_KEY
  );
}
